import { Fragment } from 'react';
import { services } from '~/ocab-services/services.constant';
import { RemoteAppointmentInformation } from '../components';
import { REMOTE_PROGRESS_BAR_ITEMS, REMOTE_EDIT_PROGRESS_BAR_ITEMS } from './progress-bar-items.config';
import { PATH_NAMES } from '../constants';

export const config = {
  v3: {
    PROGRESS_BAR_ITEMS: REMOTE_PROGRESS_BAR_ITEMS,
    EDIT_PROGRESS_BAR_ITEMS: REMOTE_EDIT_PROGRESS_BAR_ITEMS,
    editMode: {
      firstEditPagePath: PATH_NAMES.EDIT_DATE,
      hideEditDateTitle: true,
      hideGoBackButton: true,
    },
    selectDateTitle: 'Select a date',
    AboutYou: {
      YourDetails: {
        phoneNumberConfig: {
          extra: (
            <Fragment>
              <p>
                {'We\'ll send you a text to confirm your booking.'}
              </p>
              <p>
                {'We will call you on this number at the time of your appointment.'}
              </p>
            </Fragment>
          ),
        },
      },
    },
    ReviewForm: {
      hideShopDetails: true,
    },
    getSelectDateExternalPrevPath: envConfig => envConfig.services[services.FITTED_KITCHENS.name].landingPageUrl,
    subtitleComponent: ({ linkUrl, classNameForSubtitleWithLink, hideInStoreLink }) => (
      <div className={classNameForSubtitleWithLink}>
        <p>Design planning appointments are held via video call with measurements you’ve taken or from an architect’s plan.</p>
        { !hideInStoreLink
          ? (
              <p>If you need initial ideas and inspiration or would prefer to meet in person, <a href={linkUrl}>please book a showroom appointment.</a></p>
          ) : null
        }
      </div>
    ),
    hideFilters: false,
    BookingReview: {
      hideShopDetails: true,
      hidePartnerDetails: true,
    },
    BookingInformation: {
      appointmentInformation: RemoteAppointmentInformation,
    },
  },
};
